var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160.72 161.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{mix-blend-mode:multiply;opacity:.5;}.cls-3{fill:#231f20;}.cls-3,.cls-4,.cls-5{stroke-width:0px;}.cls-4{fill:#0071ae;}.cls-5{fill:#f7f7f5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 0.39,
    width: 160.72,
    height: 160.72,
    rx: 23.65,
    ry: 23.65
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 160.72,
    height: 160.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 40.84,
    y: 66.86,
    width: 19.14,
    height: 53.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M69.85,66.86h14.77v7.43s2.27-7.49,15.93-7.49c11.27,0,19.33,4.39,19.33,16.45v37.09h-15.77s.09-31.2.17-32.16c.09-.96-.87-8.83-8.91-8.83s-10.57,5.77-10.57,10.14v30.85h-14.94v-53.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 50.41,
    cy: 49.95,
    r: 9.57
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLinkedin);
export default __webpack_public_path__ + "static/media/Icons_Linkedin.22fdef8133e95803625845483e135ea4.svg";
export { ForwardRef as ReactComponent };